import React, { useState, useEffect } from 'react';
import { Accordion } from 'react-bootstrap';
import config from '../internetConfig';
import utils from '../../utils';

function WebResultFAQItem({ question, answer, eventKey }) {
	return (
		<Accordion.Item eventKey={eventKey} className="faq-item">
			<Accordion.Header>
				<span role="heading" aria-level="1" dangerouslySetInnerHTML={{ __html: question }}></span>
			</Accordion.Header>
			<Accordion.Body dangerouslySetInnerHTML={{ __html: answer }} />
		</Accordion.Item>
	);
}

export default function WebResultFAQ(props) {
	const [showMoreFAQs, setShowMoreFAQs] = useState(false);
	const faqData = utils.toArray(props.faqData);
	const resultIndex = props.resultIndex;
	const faqId = 'faq' + resultIndex;
	const webHost = utils.trailingSlash(config.webHost || '');
	const queryWords = utils.getWords(props.query || '');
	var faqs = [];

	faqData.forEach((item) => {
		let question = utils.cleanString(item && item.name);
		let answer = utils.cleanString((item && item.acceptedAnswer && item.acceptedAnswer.text) || '');
		if (webHost) {
			question = question.replace(/(href|src)\s*=\s*([\'\"])\//g, '$1=$2' + webHost);
			answer = answer.replace(/(href|src)\s*=\s*([\'\"])\//g, '$1=$2' + webHost);
		}
		if (question && answer) {
			faqs.push({
				question: utils.cleanHTML(question),
				answer: utils.cleanHTML(answer),
			});
		}
	});

	// weigh FAQs by appearance of search term
	faqs.forEach(function (faqItem, i) {
		var score = 0;
		queryWords.forEach(function (queryWord) {
			var findTerm = new RegExp(queryWord, 'gi');
			var matches = {
				question: faqItem.question.match(findTerm),
				answer: faqItem.answer.match(findTerm),
			};
			if (matches.question) {
				score += matches.question.length * 10;
			}
			if (matches.answer) {
				score += matches.answer.length;
			}
		});
		faqs[i].score = score;
	});
	// Sort FAQs by their assigned scores
	faqs.sort(function (a, b) {
		if (a.score === b.score) {
			return 0;
		}
		return a.score > b.score ? -1 : 1;
	});

	const faqsTop = faqs.splice(0, 3);
	const faqsBottom = faqs;

	const toggleMoreFAQs = () => {
		setShowMoreFAQs(!showMoreFAQs);
	};

	const allFAQsToDisplay = showMoreFAQs ? [...faqsTop, ...faqsBottom] : faqsTop;

	return (
		<div className="cdc-faq-accordion">
			<Accordion alwaysOpen>
				{allFAQsToDisplay.map((faq, faqIndex) => (
					<WebResultFAQItem
						key={faqIndex}
						question={faq.question}
						answer={faq.answer}
						eventKey={String(faqIndex)}
					/>
				))}
			</Accordion>

			{faqsBottom.length > 0 && (
				<button
					className="btn btn-more"
					type="button"
					onClick={toggleMoreFAQs}
					aria-expanded={showMoreFAQs}
				>
					{showMoreFAQs ? 'Show Less' : 'Show More'}
				</button>
			)}
		</div>
	);
}
